import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  Link,
  Paper,
  Box,
} from "@material-ui/core";
// import JsonViewer from "./JsonViewer";
import axios from "axios";
import JsonView from "@uiw/react-json-view";
import { uri } from "../../../../help/Api";

// import { nordTheme } from "@uiw/react-json-view/nord";
// import { vscodeTheme } from "@uiw/react-json-view/vscode";
// import { darkTheme } from "@uiw/react-json-view/dark";
// import { vscodeTheme } from "@uiw/react-json-view/vscode";
const customTheme = {
  '--w-rjv-font-family': 'monospace',
  '--w-rjv-color': '#9cdcfe',
  '--w-rjv-key-string': '#9cdcfe',
  '--w-rjv-background-color': '#1e1e1e',
  '--w-rjv-line-color': '#36334280',
  '--w-rjv-arrow-color': '#838383',
  '--w-rjv-edit-color': 'var(--w-rjv-color)',
  '--w-rjv-info-color': '#9c9c9c7a',
  '--w-rjv-update-color': '#9cdcfe',
  '--w-rjv-copied-color': '#9cdcfe',
  '--w-rjv-copied-success-color': '#28a745',
  '--w-rjv-curlybraces-color': '#d4d4d4',
  '--w-rjv-colon-color': '#d4d4d4',
  '--w-rjv-brackets-color': '#d4d4d4',
  '--w-rjv-quotes-color': 'var(--w-rjv-key-string)',
  '--w-rjv-quotes-string-color': 'var(--w-rjv-type-string-color)',
  '--w-rjv-type-string-color': '#ce9178',
  '--w-rjv-type-int-color': '#b5cea8',
  '--w-rjv-type-float-color': '#b5cea8',
  '--w-rjv-type-bigint-color': '#b5cea8',
  '--w-rjv-type-boolean-color': '#569cd6',
  '--w-rjv-type-date-color': '#b5cea8',
  '--w-rjv-type-url-color': '#3b89cf',
  '--w-rjv-type-null-color': '#569cd6',
  '--w-rjv-type-nan-color': '#859900',
  '--w-rjv-type-undefined-color': '#569cd6'
};

const SectionLabel = ({ tile, discription }) => {
  return (
    <>
      <Typography
        style={{
          textAlign: "right",
          marginTop: "20px",
        }}
        variant="h4"
        component="h2"
        // gutterBottom={false}
      >
        {tile}
      </Typography>
      <hr style={{ paddingTop: "0px", marginTop: "0px" }} />
      <Typography
        style={{
          textAlign: "right",
        }}
        variant="h6"
        paragraph
      >
        {discription}
      </Typography>
    </>
  );
};
const README = () => {
  const [jsonData, setJsonData] = useState({
    inv_data: {},
    headerFooterData: {},
    invoceItems: [],
  });
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setFetching(true);
      await axios
        .get(`${uri}templates/demo`)
        .then((res) => {
          setJsonData(res?.data);
          setFetching(false);
        })
        .catch((err) => {
          console.log("errors");
          setFetching(false);
        });
    };
    fetchData();
  },[]);
  return (
    // <Container dir={"rtl"} style={{ textAlign: "right" }}>
    <>
      <>
        <SectionLabel
          tile={"نظرة عامة"}
          discription={
            "يوفر هذا التوثيق دليلًا خطوة بخطوة حول كيفية استخدام مدير القوالب لتحميل قالب، وتحريره في برنامج Microsoft Word، ثم رفعه لحفظ التعديلات."
          }
        />
        <SectionLabel
          tile={"الخطوات الأساسية لاستخدام قوالب الطباعة من اوراكس"}
          discription={
            "إعداد القالب: الخطوة الأولى هي إعداد قالب Word يحتوي على الأماكن المخصصة لإدراج البيانات. يتم ذلك باستخدام علامات خاصة تسمى placeholders أو الحقول المخصصة."
          }
        />{" "}
        <Typography
          style={{
            textAlign: "right",
          }}
          variant="h6"
        >
          {
            "تعيين أسماء الحقول: يتم تعيين أسماء الحقول داخل القالب باستخدام الأقواس {}. هذه الأسماء هي ما ستستخدمه لاحقاً لإدراج البيانات في الأماكن المناسبة."
          }
        </Typography>

        <SectionLabel
          tile={"القسم الأول: البيانات العامة (رأس وتذييل القالب)"}
          discription={
            "هذا القسم يوضح كيفية استخدام البيانات العامة مثل معلومات الرأس والتذييل في القالب وفيما يلي يتم التوضيح بمثال للحقول التي يمكن استخدها "
          }
        />
        <Paper
          elevation={1}
          style={{
            padding: "30px",
            backgroundColor: "#1e1e1eff",
            direction: "ltr",
          }}
          gutterBottom
        >
          {/* <JsonViewer /> */}
          <JsonView value={jsonData?.headerFooterData} style={customTheme}/>
          
        </Paper>
        <Typography
            style={{
              textAlign: "right",
            }}
            variant="h6"
          >
            {"ملاحظة يمكنك التحكم بهذه البيانات من واجهة بيانات المؤسسة"}
          </Typography>
        <SectionLabel
          tile={"بيانات الفاتورة"}
          discription={"هنا توضيح بالحقول التي يمكن استخدامها في راس الفاتورة "}
        />
        <Paper
          elevation={1}
          style={{
            padding: "30px",
            backgroundColor: "#1e1e1eff",
            direction: "ltr",
          }}
        >
          {/* <JsonViewer /> */}
          <JsonView value={jsonData?.inv_data} style={customTheme}
          // {vscodeTheme}
          />
        </Paper>
        <SectionLabel
          tile={"بيانات منتجات الفاتورة"}
          discription={"الحقول التي يمكنك استخدامها مع جدول المنتجات في قالب الفاتورة"}
        />
        <Paper
          elevation={1}
          style={{
            padding: "30px",
            backgroundColor: "#1e1e1eff",
            direction: "ltr",
          }}
        >
          {/* <JsonViewer /> */}
          <JsonView value={jsonData?.invoceItems} style={customTheme}/>
        </Paper>
      
      </>
      {" "}
      {/* <Container>
        {" "}
        <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
          {" "}
          <Typography variant="h4" component="h1" gutterBottom>
            {" "}
            توثيق إدارة القوالب{" "}
          </Typography>{" "}
          <Typography variant="h5" component="h2" gutterBottom>
            {" "}
            مقدمة{" "}
          </Typography>{" "}
          <Typography variant="body1" paragraph>
            {" "}
            إن استخدام مكتبة docxtemplater لتحرير القوالب في ملفات Word هو عملية
            سلسة وفعالة تسمح بإدراج البيانات الديناميكية في مستنداتك بسهولة. في
            هذا الدليل، سنستعرض كيفية تعيين أسماء الحقول في قالب Word واستخدامها
            مع مكتبة docxtemplater.{" "}
          </Typography>{" "}
          <Typography variant="h5" component="h2" gutterBottom>
            {" "}
            القسم الأول: البيانات العامة (رأس وتذييل القالب){" "}
          </Typography>{" "}
          <Typography variant="body1" paragraph>
            {" "}
            هذا القسم يوضح كيفية استخدام البيانات العامة مثل معلومات الرأس
            والتذييل في القالب.{" "}
          </Typography>{" "}
          <Typography variant="body2" paragraph>
            {" "}
            مثال على البيانات العامة:{" "}
          </Typography>{" "}
          <Paper
            elevation={1}
            style={{ padding: "10px", backgroundColor: "#f5f5f5" }}
          >
            {" "}
            <Typography
              variant="body2"
              component="pre"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {" "}
              {` { "foundName": "مؤسسة السلام للدعاية", "address": "شارع الملك فهد، الرياض", "phone": "00966123456789", "email": "info@peaceads.com" } `}{" "}
            </Typography>{" "}
          </Paper>{" "}
          <Typography variant="body1" paragraph>
            {" "}
            كيفية استخدام البيانات:{" "}
          </Typography>{" "}
          <List>
            {" "}
            <ListItem>
              {" "}
              <ListItemText primary="اسم المؤسسة: {foundName}" />{" "}
            </ListItem>{" "}
            <ListItem>
              {" "}
              <ListItemText primary="العنوان: {address}" />{" "}
            </ListItem>{" "}
            <ListItem>
              {" "}
              <ListItemText primary="رقم الهاتف: {phone}" />{" "}
            </ListItem>{" "}
            <ListItem>
              {" "}
              <ListItemText primary="البريد الإلكتروني: {email}" />{" "}
            </ListItem>{" "}
          </List>{" "}
          <Typography variant="h5" component="h2" gutterBottom>
            {" "}
            القسم الثاني: بيانات الفاتورة{" "}
          </Typography>{" "}
          <Typography variant="body1" paragraph>
            {" "}
            هذا القسم يوضح كيفية استخدام البيانات المتعلقة بالفاتورة مثل رقم
            الفاتورة، اسم العميل، وتاريخ الفاتورة.{" "}
          </Typography>{" "}
          <Typography variant="body2" paragraph>
            {" "}
            مثال على بيانات الفاتورة:{" "}
          </Typography>{" "}
          <Paper
            elevation={1}
            style={{ padding: "10px", backgroundColor: "#f5f5f5" }}
          >
            {" "}
            <Typography
              variant="body2"
              component="pre"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {" "}
              {` { "id": "INV-12345", "cust_name": "محمد أحمد", "inv_date": "2023-01-01", "total_amount": "1500.00" } `}{" "}
            </Typography>{" "}
          </Paper>{" "}
          <Typography variant="body1" paragraph>
            {" "}
            كيفية استخدام البيانات:{" "}
          </Typography>{" "}
          <List>
            {" "}
            <ListItem>
              {" "}
              <ListItemText primary="رقم الفاتورة: {id}" />{" "}
            </ListItem>{" "}
            <ListItem>
              {" "}
              <ListItemText primary="اسم العميل: {cust_name}" />{" "}
            </ListItem>{" "}
            <ListItem>
              {" "}
              <ListItemText primary="تاريخ الفاتورة: {inv_date}" />{" "}
            </ListItem>{" "}
            <ListItem>
              {" "}
              <ListItemText primary="المبلغ الإجمالي: {total_amount}" />{" "}
            </ListItem>{" "}
          </List>{" "}
          <Typography variant="h5" component="h2" gutterBottom>
            {" "}
            القسم الثالث: استخدام علامة {`{#items}`} لبناء حلقات العناصر{" "}
          </Typography>{" "}
          <Typography variant="body1" paragraph>
            {" "}
            هذا القسم يوضح كيفية استخدام العلامة {`{#items}`} لعرض العناصر في
            جدول ضمن القالب.{" "}
          </Typography>{" "}
          <Typography variant="body2" paragraph>
            {" "}
            مثال على بيانات العناصر:{" "}
          </Typography>{" "}
          <Paper
            elevation={1}
            style={{ padding: "10px", backgroundColor: "#f5f5f5" }}
          >
            {" "}
            <Typography
              variant="body2"
              component="pre"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {" "}
              {` { "items": [ { "item_name": "منتج 1", "quantity": 2, "price": 500.00 }, { "item_name": "منتج 2", "quantity": 1, "price": 500.00 } ] } `}{" "}
            </Typography>{" "}
          </Paper>{" "}
          <Typography variant="body1" paragraph>
            {" "}
            كيفية استخدام البيانات:{" "}
          </Typography>{" "}
          <Typography variant="body2" paragraph>
            {" "}
            يمكنك استخدام هذه الحقول في قالب Word لبناء جدول العناصر كما يلي:{" "}
          </Typography>{" "}
          <Paper
            elevation={1}
            style={{ padding: "10px", backgroundColor: "#f5f5f5" }}
          >
            {" "}
            <Typography
              variant="body2"
              component="pre"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {" "}
              {` 1. بدء الحلقة: {#items} 2. اسم المنتج: {item_name} 3. الكمية: {quantity} 4. السعر: {price} 5. إنهاء الحلقة: {/items} `}{" "}
            </Typography>{" "}
          </Paper>{" "}
          <Typography variant="body2" paragraph>
            {" "}
            مثال على الجدول في القالب:{" "}
          </Typography>{" "}
          <Paper
            elevation={1}
            style={{ padding: "10px", backgroundColor: "#f5f5f5" }}
          >
            {" "}
            <Typography
              variant="body2"
              component="pre"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {" "}
              {` | اسم المنتج | الكمية | السعر | |------------|--------|-------| | {item_name} | {quantity} | {price} | {/items} `}{" "}
            </Typography>{" "}
          </Paper>{" "}
        </Paper>{" "}
      </Container> */}
    </>
  );
};

export default README;
